/**
 * Length of the Discovery Call shown on /book and promised in the close CTA.
 * One constant so the CTA line and the scheduler badge cannot drift apart (F564).
 */
export const DISCOVERY_CALL_MINUTES = 30;

export const CLOSE_LINE = `${DISCOVERY_CALL_MINUTES} minutes on your own call flow, and you will hear exactly what a caller hears.`;
